import { all, call, put, takeLatest } from "redux-saga/effects";

import { request } from "src/utils/api";
import { StatusCodes } from "http-status-codes";
import {
  fetchBookingFailure,
  fetchBookingSuccess,
  fetchCompanyFailure,
  fetchCompanySuccess,
  updateCompanyFailure,
  updateCompanySuccess,
  updatePrepaidFailure,
  updatePrepaidSuccess,
} from "../slices/bookingReportSlice";
import {
  FETCH_BOOKING,
  FETCH_COMPANY,
  UPDATE_COMPANY,
  UPDATE_PREPAID,
} from "../actions/bookingReportAction";
import notification from "antd/es/notification";

export function* fetchBookingSaga(action: any): Generator<any, void, any> {
  try {
    const result: any = yield call(request, action.payload);
    if (result.status == StatusCodes.OK) yield put(fetchBookingSuccess(result));
    else {
      yield put(fetchBookingFailure(result.message));
      notification.error({
        message: "Data Failed",
        description: result.message,
        placement: "topRight",
        showProgress: true,
      });
    }
  } catch (error: any) {
    yield put(fetchBookingFailure(error.message));
  }
}

export function* fetchCompanySaga(action: any): Generator<any, void, any> {
  try {
    const result: any = yield call(request, action.payload);
    if (result.status == StatusCodes.OK)
      yield put(fetchCompanySuccess(result.data));
    else {
      yield put(fetchCompanyFailure(result.message));
      notification.error({
        message: "Data Failed",
        description: result.message,
        placement: "topRight",
        showProgress: true,
      });
    }
  } catch (error: any) {
    yield put(fetchCompanyFailure(error.message));
  }
}

export function* updateCompanySaga(action: any): Generator<any, void, any> {
  try {
    const result: any = yield call(request, action.payload);
    if (result.status == StatusCodes.OK) {
      yield put(updateCompanySuccess(result.data));
      notification.success(result.message);
    } else {
      yield put(updateCompanyFailure(result.message));
      notification.error({
        message: "Update Failed",
        description: result.message,
        placement: "topRight",
        showProgress: true,
      });
    }
  } catch (error) {
    yield put(updateCompanyFailure(error));
  }
}

export function* updatePrepaidSaga(action: any): Generator<any, void, any> {
  try {
    const result: any = yield call(request, action.payload);
    if (result.status == StatusCodes.OK) {
      yield put(updatePrepaidSuccess(result.data));
      notification.success({
        message: "Success",
        description: result.message,
        placement: "topRight",
        showProgress: true,
      });
    } else {
      yield put(updatePrepaidFailure(result.message));
      notification.error({
        message: "Update Failed",
        description: result.message,
        placement: "topRight",
        showProgress: true,
      });
    }
  } catch (error) {
    yield put(updatePrepaidFailure(error));
  }
}

export default function* bookingSaga() {
  yield all([
    takeLatest(FETCH_BOOKING, fetchBookingSaga),
    takeLatest(FETCH_COMPANY, fetchCompanySaga),
    takeLatest(UPDATE_COMPANY, updateCompanySaga),
    takeLatest(UPDATE_PREPAID, updatePrepaidSaga),
  ]);
}
